import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const RANGE_PRESETS = [
  { value: 'last_30', label: 'Last 30 days' },
  { value: 'last_90', label: 'Last 90 days' },
  { value: 'since_joining', label: 'Since joining' },
  { value: 'custom', label: 'Custom' },
];

export const SESSION_FILTERS = [
  ['all', 'All'], ['open_future', 'Open/future'], ['completed', 'Completed'],
  ['cancelled', 'Cancelled'], ['zero_players', 'Zero players'], ['full', 'Full'],
  ['with_waitlist', 'With waitlist'], ['training', 'Training'], ['run', 'Run'],
];

export const getPresetDates = (preset, viewerTimezone, hostCreatedAt, now = dayjs()) => {
  const today = now.tz(viewerTimezone).startOf('day');
  const end = today.format('YYYY-MM-DD');
  if (preset === 'last_90') return { start: today.subtract(89, 'day').format('YYYY-MM-DD'), end };
  if (preset === 'since_joining' && hostCreatedAt) {
    return { start: dayjs.utc(hostCreatedAt).tz(viewerTimezone).format('YYYY-MM-DD'), end };
  }
  return { start: today.subtract(29, 'day').format('YYYY-MM-DD'), end };
};

export const validateCustomRange = (start, end) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start || '') || !/^\d{4}-\d{2}-\d{2}$/.test(end || '')) {
    return 'Enter valid start and end dates.';
  }
  if (dayjs.utc(start).format('YYYY-MM-DD') !== start || dayjs.utc(end).format('YYYY-MM-DD') !== end) {
    return 'Enter valid start and end dates.';
  }
  if (start > end) return 'Start date must be on or before end date.';
  return null;
};

export const formatPercent = (value) => value == null ? '—' : `${(value * 100).toFixed(1)}%`;
export const formatNumber = (value, digits = 0) => value == null ? '—' : Number(value).toFixed(digits);

export const performanceQuery = ({ preset, start, end, timezone, sessionFilter, clubId, page, limit = 25 }) => ({
  preset,
  start: preset === 'custom' ? start : undefined,
  end: preset === 'custom' ? end : undefined,
  viewer_timezone: timezone,
  session_filter: sessionFilter || 'all',
  club_id: clubId && clubId !== 'all' ? clubId : undefined,
  page,
  limit,
});

export const rosterQuery = ({ start, end, timezone, playerId, clubId, hostRole, includeUpcoming, includeCancelled }) => ({
  start,
  end,
  viewer_timezone: timezone,
  player_id: playerId && playerId !== 'all' ? playerId : undefined,
  club_id: clubId && clubId !== 'all' ? clubId : undefined,
  host_role: hostRole || 'all',
  include_upcoming: Boolean(includeUpcoming),
  include_cancelled: Boolean(includeCancelled),
});
